import { BetContext } from "@/context/BetContext";
import FloatDialog from "./_floatDialog";
import { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import Icon from "@/components/etc/icon";
import { AuthContext } from "@/context/authContext";
import { del_comma, with_comma } from "@/util/comma";
import customAlert from "@/util/customAlert";
import { useTranslations } from "next-intl";

export default function FloatBetslip() {
    const { user } = useContext(AuthContext)
    const {
        betSlipShow,
        setBetslipShow,
        setBetDetailShow,
        betTickets,
        clearTicket,
        betslipInfo,
        setBetslipInfo,
        addBetPoint,
        deleteSelection,
        LetsBet
    } = useContext(BetContext)

    const addPoints: number[] = [100, 200, 300, 500, 700, 1000]

    const t = useTranslations("Text")
    const a = useTranslations("Sentence")

    function MaxBet() {
        if (user.is_authenticated) {
            let setPoint = 1000
            if (user.point < 1000) {
                setPoint = user.point
            }
            setBetslipInfo(({ ...prev }) => {
                const { bet_point, ...others } = prev;
                return {
                    ...others,
                    bet_point: setPoint
                };
            });
        }
    }
    function MinBet() {
        if (user.is_authenticated) {
            if (user.point < 100) {
                customAlert(a("HavePoint100"), 'warning')
            } else {
                setBetslipInfo(({ ...prev }) => {
                    const { bet_point, ...others } = prev;
                    return {
                        ...others,
                        bet_point: 100
                    };
                });
            }
        }
    }

    return (
        <FloatDialog
            show={betSlipShow}
            setShow={setBetslipShow}
            className="betslip"
        >
            <FloatDialog.Head>
                <div className="page-tabs">
                    <ul className="box-page col4">
                        <li className="active">{t("베팅 카트")}</li>
                        <li onClick={e => {
                            setBetslipShow(false)
                            setBetDetailShow(true)
                        }}>{t("베팅 내역")}</li>
                    </ul>
                </div>
            </FloatDialog.Head>
            <FloatDialog.Body>
                <div className="betslip-container">
                    <div className="tickets-list scroll">
                        <ul>
                            {
                                betTickets.map((ti, index) => {

                                    const hometeam_name = ti.members.find((el) => el.is_home === true)?.team_name
                                    const awayteam_name = ti.members.find((el) => el.is_home === false)?.team_name
                                    return (
                                        <li key={index}>
                                            <div>
                                                <div className="market-pick">
                                                    <p>{ti.markets.name}</p>
                                                    <span>/</span>
                                                    <span>{ti.selections.name}</span>
                                                </div>
                                                <div className="versus">
                                                    <span>{hometeam_name}</span>
                                                    <span className="vs">VS</span>
                                                    <span>{awayteam_name}</span>
                                                </div>
                                            </div>
                                            <div className="odds">
                                                <p>{Number(ti.selections.odds).toFixed(2)}</p>
                                            </div>
                                            <div className="close-this-ticket">
                                                <Icon icon={`close`} onClick={e => deleteSelection(ti.selections.selection_id)} />
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                    <div className="bet-info">
                        <div>
                            <p>{t("배당률")}: <span>{Number(betslipInfo.total_odds).toFixed(2)}</span></p>
                            <p>{t("보유 포인트")}: <span>{user.is_authenticated && with_comma(user.point) || 0}P</span></p>
                        </div>
                        {/* <button onClick={e => clearTicket()}>전체 삭제</button> */}
                    </div>
                    <div className="bet-point-container">
                        <div>
                            <p>{t("베팅")} P</p>
                            <input className="bet-point" type="text"
                                onChange={e => {
                                    const setPoint = Number(e.currentTarget.value)
                                }}
                                value={with_comma(betslipInfo.bet_point)} />
                        </div>
                        <button onClick={MaxBet}>MAX</button>
                        <button onClick={MinBet}>MIN</button>
                    </div>
                    <ul className="add-point">
                        {
                            addPoints.map((num, index) => (
                                <li key={index} onClick={e => addBetPoint(num)}><button>+{num} P</button></li>
                            ))
                        }

                    </ul>
                    <footer>
                        <p>{t("예상당첨")} : <span>{with_comma(betslipInfo.expected_point)} P</span></p>
                        <button onClick={e => LetsBet()}>{t("승부예측")}</button>
                    </footer>
                </div>
            </FloatDialog.Body>
        </FloatDialog>
    )
}